import changeColorPointByRatio from './change-color-point-by-ratio';

const increaseColorPointByRatio = (params, initialShade) => {
  const fallback = {
    rule: 'increaseColorPointByRatio',
    params,
  };

  const paramsWithFallback = params.fallback ? params : { ...params, fallback };
  return changeColorPointByRatio(paramsWithFallback, initialShade, false);
};

export default increaseColorPointByRatio;
